import React, { } from "react";

import {
    Form,
    Input,
    Button,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
export default function ItemList({ items, handleOnchangeItem, removeItem, formStatus }) {
    return (
        <>

            <table className="table table-bordered table-striped table-hover">
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Uom</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td>
                                <Form.Item
                                    rules={[{ required: true, message: "Please enter" }]}
                                >
                                    <Input
                                        value={item.name}
                                        placeholder="Item"
                                        onChange={(e) => handleOnchangeItem(index, "name", e.target.value)}
                                    />
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item
                                    rules={[{ required: true, message: "Please enter" }]}
                                >
                                    <Input
                                        type="number"
                                        min={0}
                                        step={0.0001}
                                        value={item.qty}
                                        onChange={(e) => handleOnchangeItem(index, "qty", e.target.value)}
                                        placeholder="Qty"
                                    />
                                </Form.Item>
                            </td>
                            <td>
                                <Form.Item
                                    rules={[{ required: true, message: "Please enter" }]}
                                >
                                    <Input
                                        value={item.uom}
                                        onChange={(e) => handleOnchangeItem(index, "uom", e.target.value)}
                                        placeholder="UOM"
                                    />
                                </Form.Item>
                            </td>
                            <td>
                                <Button
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeItem(index)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}